export const segments = [
  {
    title: '业务类型',
    dataIndex: 'name',
    width: '33%',
  },
  {
    title: 'Segment',
    dataIndex: 'segment',
    width: '33%',
  },
  {
    title: '账期(天)',
    dataIndex: 'term',
    width: '33%',
  },
]
